import { render, staticRenderFns } from "./LootWeapons.vue?vue&type=template&id=1aa47c10&lang=pug&"
import script from "./LootWeapons.vue?vue&type=script&lang=ts&"
export * from "./LootWeapons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports